import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useEffect
} from "react";
import { withRouter } from "react-router-dom";


import {
  Button,
  Card,
  Title,
  Input,
  Select,
  RadioGroup,
  FormFooter,
  Icon,
  ButtonAction,
  Table,
  FormGroup,
  Tooltip,
  ContentBlock,
  StatusDot
} from "xsolla-uikit";
import PAgameKeysWidg from "./PAgameKeysWidg";
import { Link } from "react-router-dom";
import { ContextConsumer, GlobalContext } from '../PA';




export const WidgetWizard = props => {
  let globalContext = useContext(GlobalContext);
  return <WidgetWiz {...props} globalContext={globalContext} />;
};

export const WidgetWiz = withRouter(({ newKey, history }) => {
  const [state, setState] = useState({
    newKey: newKey || false,
    newSku: null
  });

  const handleURL = function(goto) {

    if (goto === "newwidget") {
      history.push(`/game_store/${goto}`)
    }
    if (!goto) {
      history.push("/game_store");
    }
    if (goto === "newsite") {
      history.push(`/site_builder/newsite`);
    }


  };

  const globalContext = useContext(GlobalContext);

  const getData = what => {
    // let answer;
    // if (globalContext) {
    //   answer = globalContext.globalState.store.gameKeys.keys[state.newSku] ?
    //   globalContext.globalState.store.gameKeys.keys[state.newSku].keyData.general.name.value
    //     : null
    // }
    // return answer
    return state.newName ? state.newName : null;
  };

  useEffect(() => {
    // debugger
    if (
      globalContext &&
      globalContext.globalState.game_keys.gameKeys.keys[state.newSku]
    ) {
      setState({
        ...state,
        newName:
          globalContext.globalState.game_keys.gameKeys.keys[state.newSku].keyData
            .general.name.value
      });
    }
    if (newKey !== state.newKey)
      setState({
        newKey: newKey
      });
  });

  const generateSku = (newName = "new") => {
    let timestamp = new Date().getTime().toString();
    timestamp = timestamp.substring(timestamp.length - 7, timestamp.length);
    // debugger;
    return `${newName.replace(/\s+/g, "_").toLowerCase()}_${timestamp}`;
  };
  let self = this;
  return (
    <React.Fragment>

          {/* newWidget Widget */}




            {/* Zanaveska */}
            <FormGroup indentation="lg">
              <div style={{ position: "relative" }}>
                {state.newKey && (
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 10,
                      background: "rgba(0,0,0,0.03)"
                    }}
                    onClick={e => {
                      handleURL();
                    }}
                    // onClick={e => {
                    //   setState({
                    //     newWidget: true,
                    //     newKey: false
                    //   });
                    // }}
                  />
                )}
                <FormGroup indentation="lg">
                  <PAgameKeysWidg
                    controls={state.newKey}
                    sku={state.newSku}
                    name={getData("name")}
                  />
                </FormGroup>
              </div>
            </FormGroup>



            {/* <FormGroup>
              <div className="p2p-widget" style={{display: 'flex', justifyContent: 'center', bottom: '40px'}}>

                  <pre  style={{padding: 0}}>
                  <code  style={{fontSize: 11, lineHeight: '100%' }}>{"\n"}{"      "}&lt;div id="XS-pay2play-widget"&gt;&lt;/div&gt;{"\n"}{"      "}&lt;script&gt;{"\n"}{"          "}var options = {"{"}{"\n"}{"              "}access_data: {"{"}{"\n"}{"                "}"settings": {"{"}{"\n"}{"                  "}"project_id": 37471{"\n"}{"                "}{"}"},{"\n"}{"                "}"purchase": {"{"}{"\n"}{"                  "}"pin_codes": {"{"}{"\n"}{"                    "}"codes":[{"{"}"digital_content": "My_awesome_game"{"}"}]{"\n"}{"                  "}{"}"}{"\n"}{"                "}{"}"},{"\n"}{"                "}"user": {"{"}{"\n"}{"                  "}"country": {"{"}{"\n"}{"                    "}"allow_modify": false{"\n"}{"                  "}{"}"}{"\n"}{"                "}{"}"}{"\n"}{"              "}{"}"},{"\n"}{"              "}theme : {"{"}{"\n"}{"                  "}foreground: "green",{"\n"}{"                  "}background: "light"{"\n"}{"              "}{"}"},{"\n"}{"              "}lightbox: {"{"}{"\n"}{"                  "}height: "700px",{"\n"}{"                  "}spinner: "round"{"\n"}{"              "}{"}"},{"\n"}{"              "}target_element: "#XS-pay2play-widget"{"\n"}{"          "}{"}"};{"\n"}{"          "}var s = document.createElement("script");{"\n"}{"          "}s.type = "text/javascript";{"\n"}{"          "}s.async = true;{"\n"}{"          "}s.src = "https://static.xsolla.com/embed/pay2play/2.2.2/widget.min.js";{"\n"}{"          "}s.addEventListener("load", function (e) {"{"}{"\n"}{"              "}var widgetInstance = XPay2PlayWidget.create(options);{"\n"}{"          "}{"}"}, false);{"\n"}{"          "}var head = document.getElementsByTagName("head")[0];{"\n"}{"          "}head.appendChild(s);{"\n"}{"      "}&lt;/script&gt;{"\n"}{"      "}
                  </code>
                  </pre>

                  <div className="p2p-widget__code__copy-button" style={{bottom: 80}}>
                    <button  type="button" className="ui-form__button ui-form__button--default ui-form__button--normal ui-form__button--blue ui-form__button--inline undefined"><img src="//cdn.xsolla.net/publisher-v4/duplicate-single-white.858677.svg" />
                      Copy widget code
                    </button>
                  </div>


              </div>
            </FormGroup> */}



{/*
            <FormFooter>
              <Link to="/game_store">
                <Button appearance="secondary">Copy Widget Code</Button>
              </Link>
            </FormFooter> */}

            {!state.newKey && (
                <FormGroup
                  label="Select or newWidget new game keys package"
                  indentation="lg"
                >
                  <div className="ui-form__input-group ui-form__input-group--spaced">
                    <div style={{ width: "92%" }}>
                      <FormGroup>

                          <Select
                            // disabled={this.disabled}
                            name=""
                            options={[
                              { label: <Link to="/game_store/new">My Game</Link>, value: "1" },
                              { label: <Link to="/game_store/new">My Game Ultimate Edition</Link>, value: "2" }
                            ]}
                            // searchable={this.searchable}
                            // autosize={this.autosize}
                            // size={this.size}
                            input={{
                              name: "widgTheme",
                              value: "2"
                              // onChange: this.change
                            }}
                          />

                      </FormGroup>
                    </div>

                    <div style={{ width: "10%" }}>
                      <FormGroup>
                        <Tooltip
                          label="Create game key package"
                        >
                          <Link to="/game_store/new">
                            <Button
                              appearance="square"
                              onClick={e => {
                                setState({
                                  newSku: generateSku(),
                                  newWidget: true,
                                  newKey: true
                                });
                              }}
                            >
                              <Icon name="circle-plus" />
                            </Button>
                          </Link>
                        </Tooltip>
                      </FormGroup>
                    </div>

                  </div>


                 {false && <Link to="/game_store/new">
                    <Button
                      onClick={e => {
                        setState({
                          newSku: generateSku(),
                          newWidget: true,
                          newKey: true
                        });
                      }}
                    >
                      Create game key package
                    </Button>
                  </Link>}


                </FormGroup>
              )}



    </React.Fragment>
  );
});
